module.exports = __webpack_public_path__ + "media/newstyle/images/info-orange-c75ff3cc08951b4c184b52e2ef7c959a.svg";